import React from 'react'
import ServiceSection from '../../Components/mumbai/ServiceSection';
import ServiceNowConsultingSlider from '../../Components/mumbai/ServiceNowConsultingSlider';
import MaximizeModal from '../../Components/mumbai/MaximizeModal';
import IndustriesSliderSection from '../../Components/mumbai/IndustriesSliderSection';
import ServiceNowBannerSection from '../../Components/mumbai/ServiceNowBannerSection';
import { Helmet } from 'react-helmet-async'
import HireDeveloper from '../../Components/hire/HireDeveloper';
import HeroServiceSection from '../../Components/mumbai/HeroServiceSection';
import LocationForm from '../../Components/mumbai/LocationForm';
import WhyChoose from '../../Components/mumbai/WhyChoose';
import EngagementModels from '../../Components/hire/EngagementModels';
import ServiceNowLeadForm from '../../Components/ServiceNowLeadForm';

const wellbeingData = [
    {
        id: 1,
        title: "Comprehensive Support",
        description: "We’re always here to support your Melbourne business with reliable, people-first tech solutions.",
        image: "/assets/mumbai/img2.png"
    },
    {
        id: 2,
        title: "Industry Expertise",
        description: "At Mobikode, we craft digital solutions that help Melbourne businesses truly thrive across global industries.",
        image: "/assets/mumbai/img2.png"
    },
    {
        id: 3,
        title: "Customized Solutions",
        description: "Empowering Melbourne businesses with human-centered, custom digital solutions designed to simplify operations and spark growth.",
        image: "/assets/mumbai/img2.png"
    },

];


const consultingData = [
    {
        id: 1,
        title: "ServiceNow Consulting",
        desc: "Strategic platform advisory, maturity assessments, and digital roadmap formulation tailored to optimize your ServiceNow enterprise landscape.",
        link: "/service/servicenow-consulting",
    },
    {
        id: 2,
        title: "ServiceNow Implementation",
        desc: "End-to-end multi-module deployment, configuration, and workflow automation executed with best practices for swift enterprise adoption.",
        link: "/service/servicenow-implementation",
    },
    {
        id: 3,
        title: "ServiceNow ITSM",
        desc: "Modernize service desk operations, incident triage, change management, and request fulfillment through intelligent IT service management.",
        link: "/service/servicenow-itsm",
    },
    {
        id: 4,
        title: "ServiceNow ITOM & CMDB",
        desc: "Gain real-time infrastructure visibility, build an accurate healthy CMDB, and automate event remediation with predictive discovery.",
        link: "/service/servicenow-itom-cmdb",
    },
    {
        id: 5,
        title: "ServiceNow CSM",
        desc: "Deliver connected customer experiences by breaking down silos across front, middle, and back-office teams with proactive issue resolution.",
        link: "/service/servicenow-csm",
    },
    {
        id: 6,
        title: "ServiceNow HRSD",
        desc: "Elevate employee experiences with streamlined onboarding, unified life-event journeys, and self-service HR service delivery portals.",
        link: "/service/servicenow-hrsd",
    },
    {
        id: 7,
        title: "ServiceNow AI & Automation",
        desc: "Leverage Generative AI, Now Assist, machine learning models, and virtual agents to automate complex multi-departmental workflows.",
        link: "/service/servicenow-ai-automation",
    },
    {
        id: 8,
        title: "ServiceNow Integration",
        desc: "Seamlessly integrate your ServiceNow instance with ERPs, CRMs, cloud platforms, and legacy systems via Integration Hub and custom APIs.",
        link: "/service/servicenow-integration",
    },
    {
        id: 9,
        title: "ServiceNow Custom Development",
        desc: "Build scalable, tailor-made applications and intuitive enterprise service portals using ServiceNow App Engine and UI Builder.",
        link: "/service/servicenow-custom-development",
    },
    {
        id: 10,
        title: "ServiceNow Managed Services",
        desc: "Continuous proactive support, performance monitoring, release upgrades, technical debt reduction, and platform governance.",
        link: "/service/servicenow-managed-services",
    },
    {
        id: 11,
        title: "ServiceNow Resource Augmentation",
        desc: "Scale your delivery bandwidth with certified ServiceNow architects, developers, technical consultants, and flexible dedicated pods.",
        link: "/service/servicenow-resource-augmentation",
    },
    {
        id: 12,
        title: "ServiceNow Center of Excellence (COE)",
        desc: "Build a scalable ServiceNow ecosystem with strong governance, platform standardization, continuous improvement, and enterprise-wide innovation.",
        link: "/service/servicenow-coe",
    },
];

const industriesData = [
    {
        id: 1,
        title: "Financial Services",
        desc: "At Mobikode, we help Melbourne businesses simplify operations, elevate customer experiences, and grow confidently with secure, innovative technology solutions built for the real world.",
        image: "/assets/mumbai/item1.png"
    },
    {
        id: 2,
        title: "eCommerce ",
        desc: "At Mobikode, we help Melbourne eCommerce brands grow using simple, smart, and reliable tech. We create seamless customer experiences that build real, lasting business success.",
        image: "/assets/mumbai/item2.png"
    },
    {
        id: 3,
        title: "Insurance ",
        desc: "Empowering Melbourne’s insurers to simplify claims, delight customers, and scale confidently with secure, innovative digital solutions built around the people you serve.",
        image: "/assets/mumbai/item3.png"
    },
    {
        id: 4,
        title: "Manufacturing",
        desc: "We help Melbourne manufacturers simplify daily operations and embrace smarter tech, building efficient processes that empower your people and drive long-term growth.",
        image: "/assets/mumbai/item4.png"
    },
    {
        id: 5,
        title: "Retail & Consumer Goods",
        desc: "At Mobikode, we help Melbourne brands grow. By designing simple, smart digital solutions, we elevate customer experiences, streamline your operations, and unlock real business growth.",
        image: "/assets/mumbai/item5.png"
    },
    {
        id: 6,
        title: "Healthcare & Life Sciences",
        desc: "Mobikode Melbourne empowers local healthcare and life sciences teams with smart technology. We simplify daily processes to elevate patient care and build healthier communities together.",
        image: "/assets/mumbai/item6.png"
    },
    {
        id: 7,
        title: "Media & Communications ",
        desc: "Mobikode helps Melbourne businesses build meaningful digital experiences. By blending technology and creativity, we connect you with your audience, streamline operations, and elevate your brand.",
        image: "/assets/mumbai/item7.png"
    },
    {
        id: 8,
        title: "Logistics & Transportation ",
        desc: "At Mobikode, we help Melbourne logistics businesses simplify daily operations and scale smoothly with reliable, real-world digital solutions built to deliver a better customer experience.",
        image: "/assets/mumbai/item8.png"
    },
    {
        id: 9,
        title: "Technology",
        desc: "At Mobikode, we help Melbourne businesses turn bright ideas into brilliant digital solutions. We combine real creativity with smart tech to help your company grow.",
        image: "/assets/mumbai/item9.png"
    },
    {
        id: 10,
        title: "Non Profit",
        desc: "At Mobikode Melbourne, we empower local non-profits with smart technology to amplify their reach, simplify daily operations, and spark meaningful change across our communities.",
        image: "/assets/mumbai/item10.png"
    },
    {
        id: 11,
        title: "Professional Services ",
        desc: "At Mobikode, we help Melbourne professional services simplify workflows, embrace smart tech, and build real relationships through reliable, custom digital solutions that people love.",
        image: "/assets/mumbai/item11.png"
    },
    {
        id: 12,
        title: "Real Estate ",
        desc: "At Mobikode, we help Melbourne’s real estate businesses thrive. Our smart digital tools simplify operations and build lasting connections between builders, agents, and buyers.",
        image: "/assets/mumbai/item12.png"
    },

];

function Melbourne() {
    return (
        <div>
            <Helmet>
                <title>
                    ServiceNow Consulting in Melbourne | ITSM & Automation | Mobikode
                </title>

                <meta
                    name="description"
                    content="Mobikode delivers ServiceNow consulting in Melbourne to help businesses streamline IT operations, automate workflows, integrate enterprise systems, and improve service management with scalable digital solutions."
                />

                <meta
                    name="keywords"
                    content="ServiceNow Consulting Melbourne, ServiceNow Consultant Melbourne, ServiceNow Implementation Melbourne, ServiceNow Integration Melbourne, ServiceNow ITSM Melbourne, ServiceNow Managed Services Melbourne, ServiceNow Automation Melbourne, ServiceNow Development Melbourne, ServiceNow Solutions Melbourne, ServiceNow Consulting Company Melbourne"
                />

                <link
                    rel="canonical"
                    href="https://www.mobikode.com/location/leverage-serviceNow-consulting-in-melbourne"
                />

                <meta
                    property="og:title"
                    content="ServiceNow Consulting in Melbourne | Mobikode"
                />

                <meta
                    property="og:description"
                    content="Transform service management with Mobikode's ServiceNow consulting solutions in Melbourne. Improve workflows, automate processes, connect business systems, and build efficient digital operations."
                />

                <meta
                    property="og:url"
                    content="https://www.mobikode.com/location/leverage-serviceNow-consulting-in-melbourne"
                />

                <meta
                    property="og:type"
                    content="website"
                />

                <meta
                    property="og:image"
                    content="https://www.mobikode.com/assets/melbourne/bg1.png"
                />

                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="ServiceNow Consulting in Melbourne | Mobikode"
                />

                <meta
                    name="twitter:description"
                    content="Get tailored ServiceNow consulting solutions in Melbourne for IT service management, workflow automation, system integration, and Enterprise AI & ServiceNow Consulting."
                />

                <meta
                    name="twitter:image"
                    content="https://www.mobikode.com/assets/melbourne/bg1.png"
                />
            </Helmet>
            <HeroServiceSection bgImage="/assets/mumbai/bg1.png" title="Leverage ServiceNow Consulting in Melbourne" description="Partner with Mobikode’s ServiceNow experts in Melbourne to simplify daily operations, empower your teams, automate business processes, and achieve sustainable growth through intelligent digital transformation. Trusted by Startups and Leading Companies Worldwide" />
            <ServiceNowLeadForm bgImage="/assets/mumbai/Melbourne.png" />
            <ServiceNowConsultingSlider consultingData={consultingData} />
            <WhyChoose />
            <MaximizeModal wellbeingData={wellbeingData} />
            <EngagementModels />
            <IndustriesSliderSection industriesData={industriesData} />
            {/* <section className="relative w-full h-[500px] lg:h-[630px] flex items-center bg-[#000814] overflow-hidden py-12 md:py-0">
                <div className="absolute inset-0 z-0">
                    <img
                        src="/assets/mumbai/bg1.png"
                        alt="Abstract 3D Background"
                        className="w-full h-full object-cover"
                    />
                    <div
                        style={{ background: "linear-gradient(86.84deg, #000000 20%, rgba(0, 0, 0, 0) 79%)" }}
                        className="hidden md:block absolute inset-0"
                    ></div>
                    <div
                        style={{ background: "linear-gradient(0deg, #000000 40%, rgba(0, 0, 0, 0.3) 100%)" }}
                        className="block md:hidden absolute inset-0"
                    ></div>
                </div>

                <div className="relative z-10 w-full max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px] flex flex-col items-start justify-center h-full">
                    <div className="w-full max-w-[500px] md:max-w-[700px] lg:max-w-[900px] mt-auto md:mt-0">
                        <h1 className="text-white font-[600] text-[28px] sm:text-[36px] md:text-[50px] lg:text-[60px] font-sora leading-[1.2] lg:leading-[1.1] mb-[12px] lg:mb-[22px] drop-shadow-xl tracking-wide text-left">
                            Leverage ServiceNow Consulting in Melbourne
                        </h1>
                        <p className="text-[#FFFFFF] max-w-[800px] w-full text-[14px] sm:text-[16px] md:text-[18px] leading-[20px] md:leading-[22px] lg:leading-[24px] font-graphik font-light tracking-wider text-left opacity-90 lg:opacity-100">
                            Transform how you work. Partner with Mobikode Melbourne to drive growth with expert ServiceNow solutions.
                        </p>
                    </div>
                </div>
            </section> */}
            {/* <ServiceSection image={"/assets/mumbai/Melbourne.png"}
                text={"At Mobikode, we help Melbourne businesses truly thrive with ServiceNow. We break down complex workflows into simple, automated processes tailored just for you, from seamless integration to everyday support. By focusing on real efficiency and great user experiences, we build scalable solutions that power your team and drive your digital transformation forward."}
                title={"ServiceNow Consulting"} />
            <ServiceNowConsultingSlider consultingData={consultingData} />
            <MaximizeModal wellbeingData={wellbeingData} />
            <IndustriesSliderSection industriesData={industriesData} />
            <ServiceNowBannerSection imgs={"/assets/mumbai/img3.png"}
                title="ServiceNow Consulting Services"
                text="At Mobikode Melbourne, we transform how businesses work. Through tailored ServiceNow consulting and smart automation, we simplify your everyday processes to create smoother, happier digital experiences." />
            <HireDeveloper /> */}
        </div>
    )
}

export default Melbourne
